import { render, staticRenderFns } from "./TransactionDesk.vue?vue&type=template&id=6bacd19e&lang=pug"
import script from "./TransactionDesk.vue?vue&type=script&lang=js"
export * from "./TransactionDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports